<template>
  <app-layout>
    <transition enter-active-class="animated fadeIn">
      <router-view />
    </transition>
  </app-layout>
</template>

<script>
import AppLayout from "../../layouts/AppLayout";

export default {
  components: {
    "app-layout": AppLayout,
  },
};
</script>
